/**
 * Minimální zásoba materiálu per sklad (TelcoTrack DB).
 *
 * `minQuantity` i `quantityAvailable` jsou ve **skladové (usage)** jednotce
 * stejné jako `formatMaterialQuantityLabel(..., 'stock')` — typicky ks / m,
 * nikoli nákupní balení.
 */

/**
 * true = dostupná zásoba je pod nastaveným minimem.
 * Chybějící / neplatné / ≤0 minimum = bez alertu.
 */
export function isMaterialStockBelowMinimum(
  quantityAvailable: number,
  minQuantity: number | null | undefined,
): boolean {
  if (minQuantity == null || !Number.isFinite(minQuantity) || minQuantity <= 0) {
    return false;
  }
  if (!Number.isFinite(quantityAvailable)) {
    return false;
  }
  return quantityAvailable < minQuantity;
}
